export default "__VITE_ASSET__C7OYnSh0__"